export default "__VITE_ASSET__f4f1ee69__"